module.exports = __webpack_public_path__ + "static/media/akira.5b69db72.png";